import JDFLogo from '../../assets/svg/jdf_logo.svg';
import {ACCOUNT_SELECTION_SHOWN_KEY} from '../../utils/constant';
import Smartlook from '../../utils/smartlook';
import {sendScreenViewNR} from '../../utils/util';
import SkeletonLoader from '../skeletonLoader/SkeletonLoader';
import './signOut.css';

import {Button} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate, useSearchParams} from 'react-router-dom';

const SignOut = (props) => {
  const {t} = useTranslation();
  const [searchParams] = useSearchParams();
  let navigate = useNavigate();
  const handleRedirect = () => {
    navigate('/');
  };
  const [isLoading, setIsLoading] = React.useState(false);
  React.useEffect(() => {
    localStorage.removeItem('hasLoggedInBefore');
    localStorage.removeItem(ACCOUNT_SELECTION_SHOWN_KEY);
    async function signOut() {
      if (
        props.oktaAuth &&
        (await props.oktaAuth.isAuthenticated()) &&
        searchParams.get('isRedirected') === 'true'
      ) {
        setIsLoading(true);
        await props.oktaAuth.signOut({
          postLogoutRedirectUri: `${globalThis.location.origin}/signOut`,
        });
      }
    }
    signOut();
  }, []);

  React.useEffect(() => {
    sendScreenViewNR('SignOut');
    Smartlook.navigation('SignOut');
  }, []);

  return (
    <>
      {isLoading ? (
        <SkeletonLoader componentName="LoginPage" />
      ) : (
        <div className="signOutWrapper">
          <div className="signOutCard">
            <div className="signOutCardItem">
              <img src={JDFLogo} alt="JDF Logo" />
            </div>
            <div className="signOutCardItem">{t('LOGOUT_SCREEN_TEXT')}</div>
            <div className="signOutCardItem">
              <Button variant="primary" onClick={handleRedirect}>
                {t('LOGIN')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignOut;
